export default function Banner({ style }) {
  return null;
}
